import { render, staticRenderFns } from "./EventDeleteModal.vue?vue&type=template&id=460e8b34&"
import script from "./EventDeleteModal.vue?vue&type=script&lang=js&"
export * from "./EventDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports